module.exports = __webpack_public_path__ + "03c85664fb3ba7db61e1b0c6da73b1ae.png";